module.exports = __webpack_public_path__ + "static/media/lifting.b5c8bfee.png";